import store from 'store2';
import jsPsychHtmlKeyboardResponse from '@jspsych/plugin-html-keyboard-response';
// import jsPsychHtmlButtonResponse from '@jspsych/plugin-html-button-response';
import { getPracticeStimulusMultiAFC, getStimulusMultiAFC } from '../helperFunctions';

export const setup_fixation = (numAFC, trialType) => ({
  type: jsPsychHtmlKeyboardResponse,
  stimulus: `<div class = "stimulus_div"><p class = 'stimulus'>+</p></div>`,
  choices: 'NO_KEYS',
  trial_duration: store.session.get('config').timing.fixationTime,
  data: {
    task: 'fixation',
  },
  on_finish: function () {
    if (trialType === 'practice_response') {
      store.session.set('nextStimulus', getPracticeStimulusMultiAFC(numAFC));
    } else {
      store.session.set('nextStimulus', getStimulusMultiAFC(numAFC));
    }
  },
});

/* export const setup_fixation = (numAFC, trialType) => ({
  type: jsPsychHtmlButtonResponse,
  stimulus: ``,
  button_html: `<div class = "stimulus"><img class = 'continue-center' draggable="false" src="%choice%" /></div>`,
  choices: [mediaAssets.images.go],
  // choices: 'NO_KEYS',
  // trial_duration: store.session.get('config').timing.fixationTime,
  data: {
    task: 'fixation',
  },
  on_finish: function () {
    if (trialType === 'practice_response') {
      store.session.set('nextStimulus', getPracticeStimulusMultiAFC(numAFC));
    } else {
      store.session.set('nextStimulus', getStimulusMultiAFC(numAFC));
    }
  },
});
*/
